import { FC, useMemo, ReactNode } from 'react'
import styles from 'components/features/pfm/ProviderSearchInputDecoration/ProviderSearchInputDecoration.styl'
import cn from 'classnames'

export type ProviderSearchInputDecorationProps = {
  hasValue: boolean
  hasFocus: boolean
  label: ReactNode
  error?: string
  mode?: 'regular' | 'floatingPane'
}

export const ProviderSearchInputDecoration: FC<ProviderSearchInputDecorationProps> = (props) => {
  const { children, label, error, hasValue, hasFocus, mode = 'regular' } = props

  const className = useMemo(() => {
    return cn(
      styles.formFieldDecoration,
      {
        [styles.focused]: hasFocus,
        [styles.expanded]: Boolean(hasValue || hasFocus),
        [styles.hasError]: !!error,
      },
      styles[mode],
    )
  }, [hasValue, hasFocus, error, mode])

  return (
    <label className={ className }>
      <div className={ styles.label }>
        { label }
      </div>
      <div className={ styles.input }>
        { children }
      </div>
      { error && (
        <div className={ styles.error }>
          { error }
        </div>
      )}
    </label>
  )
}
